var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 61,
    viewBox: "0 0 69 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12912_44219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8626 3.86914H38.4551V5.27851H39.8626V3.86914Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0618 3.86914H41.6543V5.27851H43.0618V3.86914Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6661 3.86914H27.584V5.27851H36.6661V3.86914Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5325 17.8965H37.125V19.3059H38.5325V17.8965Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 17.8965H33.9258V19.3059H35.3333V17.8965Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.348 17.8965H40.3242V19.3059H63.348V17.8965Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6384 22.6475H28.2812V24.0568H63.6384V22.6475Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6384 27.3994H28.2812V28.8088H63.6384V27.3994Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6384 32.1504H28.2812V33.5598H63.6384V32.1504Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6384 36.9023H28.2812V38.3117H63.6384V36.9023Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6384 41.6533H28.2812V43.0627H63.6384V41.6533Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.603 46.4053H28.2812V47.8146H55.603V46.4053Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1543 13.357V4.80469H56.5618V11.9476H63.7015V13.357H55.1543Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.418 60.9999V0.00634766H56.1496L68.5008 12.3614V60.9999H23.418ZM24.8254 59.5905H67.0933V12.9469L55.5674 1.41571H24.8254V59.5905Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5872 55.3164H37.1797V56.7258H38.5872V55.3164Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9915 55.3164H27.584V56.7258H28.9915V55.3164Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1887 55.3164H30.7812V56.7258H32.1887V55.3164Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3879 55.3164H33.9805V56.7258H35.3879V55.3164Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 61V0H18.3059V1.40937H1.90748V59.5906H4.34114V5.06475H5.74862V59.5906H8.32431V5.06475H9.73179V59.5906H12.3075V5.06475H13.715V59.5906H16.2919V11.471H17.6994V59.5906H18.3059V61H0.5Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6985 5.06494H16.291V6.47431H17.6985V5.06494Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6985 8.26807H16.291V9.67743H17.6985V8.26807Z",
    fill: "#106C3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12912_44219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 61,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a1c18955d938536f39a82ed791b1cedb.svg";
export { ForwardRef as ReactComponent };